import React, { useState } from 'react'
import MemberPregnancyForm from '../../controllers/forms/MemberPregnancyForm'
import { getMemberProfileFormErrors, getProfileMemberFields } from '../../../utils/member/baseProfileUtils'
import { getMemberApiBody, getProfileFormInitialValues } from '../../../constants/constants'
import { Alert, type AlertColor, Box, Snackbar } from '@mui/material'
import { type IMemberSummary } from '../../../interfaces/member-summary.interface'
import { type IFormValues } from '../../../interfaces/forms.interface'

interface IPregInfoProps {
  memberObj: IMemberSummary
  apiActions: any
  profileViewActions: any
}

export default function PregnancyInformationPane (props: IPregInfoProps): JSX.Element {
  const [snackbarOpen, setSnackbarOpen] = useState(false)
  const [snackbarMessage, setSnackbarMessage] = useState('')
  const [snackbarSeverity, setSnackbarSeverity] = useState('success')
  const memberFields = getProfileMemberFields()

  const getInitialValues = (): IFormValues => {
    return getProfileFormInitialValues(memberFields, props.memberObj)
  }

  const handleFormSubmit = async (formData: any): Promise<any> => {
    const submitPromise = new Promise((resolve, reject) => {
      const apiBody = getMemberApiBody(memberFields, formData, props.memberObj.user.group as string)

      props.apiActions.updateUser(
        {
          id: props.memberObj.user.id,
          promise: { resolve, reject },
          promiseTransformer: errors => getMemberProfileFormErrors(errors, memberFields)
        },
        apiBody
      )
    })

    return await submitPromise.then(handleFormSubmitSuccess).catch(data => data)
  }

  const handleFormSubmitSuccess = (): void => {
    setSnackbarMessage('Successfully updated pregnancy details.')
    setSnackbarSeverity('success')
    setSnackbarOpen(true)
  }

  const handleCloseSnackbar = (): void => {
    setSnackbarOpen(false)
  }

  const renderForm = (): JSX.Element => {
    return (
      <MemberPregnancyForm
        onSubmit={handleFormSubmit}
        onCancel={() => props.profileViewActions.handleClearModal()}
        getInitialValues={getInitialValues}
      />
    )
  }

  const renderFeedback = (): JSX.Element => {
    return (
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        key='edit-pregnancy-pane__success__snack-bar'
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity as AlertColor} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    )
  }

  const renderProfileInformationPage = (): JSX.Element => {
    return (
      <Box data-testid='edit-pregnancy-pane'>
        {renderForm()}
        {renderFeedback()}
      </Box>
    )
  }

  return renderProfileInformationPage()
}
